export default __webpack_public_path__ + "static/media/athleteAds1.1641c361.jpg";